var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Page',[_c('div',{staticClass:"centered"},[_c('Breadcrumb',{attrs:{"crumbs":[
				{
					text : 'Home',
					to : {name:'templates'},
				},
				{
					text : 'Organisations',
					to : {name:'orgs'},
				},
				{
					text : _vm.org.name || 'Personal projects',
					to : {name:'org',params:{org_id:_vm.org.id}},
				} ]}}),_vm._v(" "),_c('OrgNav',{attrs:{"org":_vm.org}}),_vm._v(" "),_c('router-view',{attrs:{"org":_vm.org}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }